import { render, staticRenderFns } from "./AddActivityNoteModal.vue?vue&type=template&id=0ff65e06&scoped=true&"
import script from "./AddActivityNoteModal.vue?vue&type=script&lang=js&"
export * from "./AddActivityNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./AddActivityNoteModal.vue?vue&type=style&index=0&id=0ff65e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff65e06",
  null
  
)

export default component.exports